/**
 * @generated SignedSource<<49cd69ffe5b174271a2559beba3e8d9d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespContentModuleSelector_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespContentModuleRegular_user" | "sellerBrandingHelpers_user">;
  readonly " $fragmentType": "SbRespContentModuleSelector_user";
};
export type SbRespContentModuleSelector_user$key = {
  readonly " $data"?: SbRespContentModuleSelector_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespContentModuleSelector_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespContentModuleSelector_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespContentModuleRegular_user"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "sellerBrandingHelpers_user",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TradeFirmType",
          "kind": "LinkedField",
          "name": "tradeFirm",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TradeFirmRewards",
              "kind": "LinkedField",
              "name": "rewards",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ParentProgram",
                  "kind": "LinkedField",
                  "name": "currentProgram",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LoyaltyProgram",
                      "kind": "LinkedField",
                      "name": "programInfo",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "3b86172cea04d8792aa3a9da31a8d5f8";

export default node;
